module.exports = __webpack_public_path__ + "img/pen-clip.d864cd6d.svg";